import Autoform from "./autoform/Autoform";
import Form from "./form/Form";
import Spreadsheet from "./spreadsheet/Spreadsheet";
import TreeView from "./tree/TreeView";

export default {
  registerAll: () => {
    Autoform.register();
    Form.register();
    Spreadsheet.register();
    TreeView.register();
  },
};
